import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Button, Col, Row} from "react-bootstrap";

import "./VehicleList.scss"
import classes from "./VehicleList.scss.json"
import VehicleSpecItem from "../../../components/VehicleSpecItem/VehicleSpecItem";
import cx from "classnames";
import VehiclePicture from "../../../components/VehiclePicture/VehiclePicture";
import VehicleDefaultModel from "../../../components/VehicleDefaultModel/VehicleDefaultModel";
import AgencyName from "../../../components/AgencyName/AgencyName";
import VehicleGridItem from "./VehicleGridItem";
import VehiclePictureCarousel from "../../../components/VehiclePicture/VehiclePictureCarousel";
import { useStyleContext } from '../../../../customHooks/useStyleContext';
import { getDisplayPictures, isVehicleSearchResultMode } from '../../../../service/vehicleDisplayPictures';
import AmountDisplay from '../../../components/AmountDisplay/AmountDisplay';
import AlertDialog from '../../../components/AlertDialog/AlertDialog';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMapMarkerAlt} from "@fortawesome/free-solid-svg-icons";


const VehicleItem = ({vehicle, selected = false, searchParameters, loading = false, onSelect, agencyCount = 0, startAgency, cardFormat = "line", suggested = false, showAgency = false, isSearchStale = false}) => {

    const styleContext = useStyleContext();

    const [displaySearchWarning, setDisplaySearchWarning] = useState(false);

    const disableAgencies = useMemo(() => {
        return styleContext?.app_config?.disable_agency_choice ?? false
    }, [styleContext]);

    const vehicleSearchResultMode = useMemo(() => {
        return isVehicleSearchResultMode(styleContext?.app_config?.vehicle_search_result);
    }, [styleContext?.app_config?.vehicle_search_result]);

    const subtitleMode = useMemo(() => {
        return vehicle?.category?.subtitle_mode ?? "default"
    }, [vehicle]);

    const subtitle = useMemo(() => {
        if(vehicle?.category?.subtitle_mode === "enabled") {
            return vehicle?.category?.custom_subtitle
        } else if(vehicle?.category?.subtitle_mode === "disabled") {
            return ""
        }
        return "ou similaire"
    }, [vehicle]);

    const descriptionLink = useMemo(() => {
        if(vehicle?.category?.view_description_link_mode === "enabled") {
            return vehicle?.category?.view_description_link
        } else if(vehicle?.category?.view_description_link_mode === "disabled") {
            return ""
        }
        return ""
    }, [vehicle]);

    const pictures = useMemo(() => {
        return getDisplayPictures({
            vehicleSearchResult: styleContext?.app_config?.vehicle_search_result,
            vehiclePictures: vehicle?.pictures,
            categoryPictures: vehicle?.category?.pictures,
            pictureUrlFallback: vehicle?.picture_url,
        });
    }, [vehicle, styleContext?.app_config?.vehicle_search_result]);

    const selectedPictureUrl = pictures?.[0]?.url;

    const handleSelect = () => {
        if (suggested) {
            onSelect && onSelect(vehicle?.agency);
        } else {
            onSelect && onSelect();
        }
    }

    useEffect(() => {
        if(searchParameters) {
            let showButton = true

            if(!searchParameters?.start_date || !searchParameters?.end_date ) {
                showButton = false
            }
            if((!searchParameters?.start_agency || !searchParameters?.end_agency)) {
                if (!styleContext?.app_config?.disable_agency_choice) {
                    showButton = false
                }
            }

            if(vehicle?.booking_amount == null || vehicle?.booking_amount < 0) {
                showButton = false
            }
            setDisplaySearchWarning(!showButton)
        }
    }, [searchParameters, vehicle]);

    if(cardFormat === 'grid') {
        return (
            <VehicleGridItem
                vehicle={vehicle}
                searchParameters={searchParameters}
                loading={loading}
                onSelect={onSelect}
                agencyCount={agencyCount}
                startAgency={startAgency}
                subtitleMode={subtitleMode}
                subtitle={subtitle}
                displaySearchWarning={displaySearchWarning}
                disableAgencies={disableAgencies}
                pictures={pictures}
                descriptionLink={descriptionLink}
                showAgency={showAgency}
                suggested={suggested}
                isSearchStale={isSearchStale}
                vehicleSearchResultMode={vehicleSearchResultMode}
            />
        )
    }

    return (
        <div className={cx({"mb-2" : !selected})}>
            {selected &&
                <Row>
                    <Col className={"px-0"}>
                        <div className={cx(classes.selectedLabel, "d-inline-block px-2")}>Votre sélection</div>
                    </Col>
                </Row>
            }
            <Row style={{minHeight: "109px"}} className={cx("shadow-sm p-0 py-2 px-md-3 align-items-center bg-white", {"opacity-50": !vehicle.is_available },{[classes.selected]: selected})}>

                {showAgency && (
                    <Col xs={12} className={"mb-1 d-flex"}>
                        <div className={"rounded-pill px-3 bg-main-light"}>
                            <FontAwesomeIcon icon={faMapMarkerAlt} className={cx("c-grey fs14 me-1")} />
                            <span className={""}>Agence : {(vehicle?.agency?.public_name || vehicle?.agency?.name)?.toUpperCase()}</span>
                        </div>
                    </Col>
                )}

                <Col xs={4} lg={2} >
                    {pictures?.length > 1 ? (
                        <VehiclePictureCarousel
                            pictures={pictures}
                            id={`vehicle_${vehicle?.id}`}
                            vehicleType={vehicle?.category?.vehicle_type}
                        />
                    ): (
                        <VehiclePicture
                            className={cx(classes.vehiclePicture, "w-100 bradius-5")}
                            url={selectedPictureUrl}
                            vehicleType={vehicle?.category?.vehicle_type}
                        />
                    )}
                </Col>
                <Col xs={8} lg={5} >
                    <div className={"d-flex flex-column px-md-4 fs14"}>
                        <p>
                            <span className={"bold fs18 no-tr"}><VehicleDefaultModel vehicle={vehicle}/> </span>
                            {subtitleMode !== 'disabled' && <span className={"fst-italic fs14"}>{subtitle}</span>}
                        </p>
                        {descriptionLink && (
                            <p className={"fs14"}>
                                <a className='c-main' href={descriptionLink} target={"_blank"} rel={"noreferrer"}>Voir le descriptif</a>
                            </p>
                        )}

                        {vehicle?.category?.search_result_format === "custom" ? (
                            <Row className={"mt-2"}>
                                {vehicle?.category?.custom_vehicle_details?.map((detail, index) => {
                                    return (detail?.icon || detail.label) && <Col xs={12} key={`custom_detail_item_${index}_${detail?.id}`}><VehicleSpecItem websiteStyle={styleContext} iconName={detail?.icon ?? "ac"} label={detail.label ?? ""}/></Col>
                                })}
                            </Row>
                        ):(
                            <Row className={"mt-2"}>
                                {vehicle?.nb_places > 0 && (<Col xs={6}><VehicleSpecItem websiteStyle={styleContext} iconName={"seat"} label={`${vehicle.nb_places} places`}/></Col>)}
                                {vehicle?.specificities?.cooling && (<Col xs={6}><VehicleSpecItem websiteStyle={styleContext} iconName={"ac"}  label={"Climatisation"}/></Col>)}
                                {vehicle?.energy && (<Col xs={6}><VehicleSpecItem websiteStyle={styleContext} iconName={"gas"} label={vehicle.energy}/></Col>)}
                                {vehicle?.nb_doors ? (<Col xs={6}><VehicleSpecItem websiteStyle={styleContext} iconName={"door"} label={`${vehicle.nb_doors} portes`}/></Col>) : <></>}
                                {vehicle?.gearbox && (<Col xs={6}><VehicleSpecItem websiteStyle={styleContext} iconName={"shifter"} label={vehicle.gearbox}/></Col>)}
                            </Row>
                        )}
                    </div>
                </Col>
                <Col lg={5} className={"h-100 mt-4 mt-lg-0"}>
                    {loading ?
                        <p className={"text-center"}>Actualisation en cours...</p>
                    :
                    <>
                        {vehicle.is_available ?
                            (displaySearchWarning ?
                                    <>
                                        <p className={"text-center medium fst-italic fs16 opacity-50"}><span>Veuillez renseigner vos dates</span>{(agencyCount > 1 && !disableAgencies) && <span>& agences</span>}</p>
                                    </>
                            :
                                <div className={"px-2 h-100 w-100 py-2 fs14"}>
                                    <Row className={"align-items-center justify-content-lg-end justify-content-center"}>
                                        {(!selected && styleContext?.payment_enabled) && (
                                            <Col xs={6}>
                                                {styleContext?.payment_enabled && (<p className={"medium mb-1"}>Paiement en ligne</p>)}
                                            </Col>
                                        )}
                                        <Col xs={6}>
                                            {isSearchStale ? (
                                                <p className={"text-center medium fst-italic fs14 opacity-50 py-2"}>Cliquez sur Rechercher pour voir les tarifs</p>
                                            ) : onSelect != null ? (
                                                <Button
                                                    disabled={vehicle?.booking_amount < 0}
                                                    onClick={handleSelect}
                                                    className={"c-white p-2 px-3 medium d-flex justify-content-center align-items-center flex-column w-100 fs14"}
                                                >
                                                    <p>Réserver pour <span className={"medium no-tr"}>
                                                        <AmountDisplay
                                                            tariffDisplayMode={vehicle?.tariff_display_mode}
                                                            invoicingMode={vehicle?.pricing_group_invoicing_mode}
                                                            exclAmount={vehicle?.booking_excl_amount}
                                                            inclAmount={vehicle?.booking_incl_amount}
                                                            defaultAmount={vehicle?.booking_amount}
                                                        />
                                                    </span></p>
                                                </Button>
                                            ) : (
                                                <p className={"bradius-5 border-main c-main p-2 px-3 medium text-center fs16"}>
                                                    <AmountDisplay
                                                        tariffDisplayMode={vehicle?.tariff_display_mode}
                                                        invoicingMode={vehicle?.pricing_group_invoicing_mode}
                                                        exclAmount={vehicle?.booking_excl_amount}
                                                        inclAmount={vehicle?.booking_incl_amount}
                                                        defaultAmount={vehicle?.booking_amount}
                                                    />
                                                </p>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            )
                        :
                            <>
                                {(startAgency && !styleContext?.app_config?.disable_agency_choice && agencyCount > 1) && <p className={"text-center medium fst-italic fs14 opacity-50"}>Agence <AgencyName agency={startAgency} /></p>}
                                <p className={"text-center medium fst-italic fs14 opacity-50"}>{vehicleSearchResultMode ? "Pas disponible à ces dates" : "Aucun véhicule disponible à ces dates"}</p>
                            </>
                        }
                    </>}
                </Col>
            </Row>
        </div>
    );
};

export default VehicleItem;

// NOTE: not used
export const AlertAgencies = React.memo(({
    vehicle,
    alertDialogOpen,
    setAlertDialogOpen,
    onSelect
}) => {
    return (
        <AlertDialog
            isOpen={alertDialogOpen}
            handleClose={() => setAlertDialogOpen((prev) => !prev)}
        >
            <div className={"d-flex flex-column align-items-center"}>
                <p className={"fs16 medium text-center mb-5"}>Votre sélection est disponible dans plusieurs agences</p>
                <p className={"fs14 medium text-center"}>Veuillez choisir l'agence de prise en charge</p>
                <div className={"d-flex flex-column align-items-center mt-3"}>
                    {vehicle?.agencies?.map((agency, index) => (
                        <Button
                            key={`agency_${index}`}
                            onClick={() => {
                                onSelect && onSelect(agency);
                                setAlertDialogOpen(false);
                            }}
                            className={"c-white p-2 px-3 medium d-flex justify-content-center align-items-center flex-column w-100 fs14 my-1"}
                        >
                            <p>{agency?.public_name || agency?.name}</p>
                        </Button>
                    ))}
                </div>
            </div>
        </AlertDialog>
    );
});